import React, { Component } from 'react';

import * as emailjs from 'emailjs-com';

import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography'



const INITIAL_STATE = {

};

const ERROR_CODE_ACCOUNT_EXISTS ='auth/account-exists-with-different-credential';

const ERROR_MSG_ACCOUNT_EXISTS = `
  An account with an E-Mail address to
  this social account already exists. Try to login from
  this account instead and associate your social accounts on
  your personal account page.
`;

class SignInFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = {

      email: '',
      fullname: '',
      message: '',
    };
    this.onSubmit= this.onSubmit.bind(this);
  }

  onSubmit = () => {
    console.log("Got here")
    const templateParams ={
      "email":this.state.email,
      "fullname":this.state.fullname,
      "message":this.state.message
    }
    var service_id = "default_service";
    var template_id = "received_a_lead";
    emailjs.send(service_id, template_id, templateParams,'user_IIXSfQkpkB9MvfzqwbBLk');
    this.props.history.push(`/`);
  };



  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, fullname, message, error } = this.state;

    return (
      <div style={{backgroundColor:''}} >

<Container >
<Typography color='primary' gutterBottom style={{fontSize:'20px'}} variant='overline'>
Request Software Quote
</Typography>
<Typography color='primary' gutterBottom style={ {fontSize:'18px'}} variant='overline' component='h1'>
Or Call (847) 548-1588
</Typography>
<Typography  gutterBottom style={{ fontSize:'14px'}} variant='overline' component='h3'>
We want to hear more about you! Give us a description of your ideas and goals. One of our project managers will reach out to you shortly.
</Typography>

      <form id='form' onSubmit={this.onSubmit}>
        <TextField
           variant="outlined"
           margin="normal"
           required
           fullWidth
           id="email"
           label="Email Address"
           name="email"
           type="email"
           value={email}
           onChange={this.onChange}
           autoComplete="email"
           autoFocus
         />
         <TextField
           variant="outlined"
           margin="normal"
           required
           fullWidth
           value={fullname}
           onChange={this.onChange}
           name="fullname"
           type="name"

           label="Full Name"
           type="normal"
           id="name"
         />
         <TextField
           variant="outlined"
           margin="normal"
           required
           fullWidth
           onChange={this.onChange}
           name="message"
           value={message}
           label="Tell us about what you're looking for below!"
           rows="4"
           multiline
           id="proposal"

         />
         <Button
         onClick={this.onSubmit}
           fullWidth
           margin='normal'
           variant="contained"
           color="primary"
         >
           Request Quote
         </Button>



        {error && <p>{error.message}</p>}
      </form>
      </Container>
      </div>


    );
  }
}






export default SignInFormBase;
